var _CloseSmall;
import CloseSmall from '@crehana/compass.icons.outline/CloseSmall';
import { clsx } from 'clsx';
import { TOAST_COLORS } from "../constants";
import { ToastIcon } from "./ToastIcon";
import { ToastInformation } from "./ToastInformation";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ToastContent = function ToastContent(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    textLink = _ref.textLink,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'informative' : _ref$type,
    onClose = _ref.onClose;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-w-[32.8rem] sm:tw-w-[38rem] tw-flex tw-items-start",
    children: [/*#__PURE__*/_jsx("div", {
      className: clsx('tw-rounded-l-1 tw-h-full tw-w-0.4 tw-flex-shrink-0', TOAST_COLORS[type].leftBorder.light, TOAST_COLORS[type].leftBorder.dark)
    }), /*#__PURE__*/_jsxs("div", {
      className: clsx('dark:tw-bg-elevation-dark-03 tw-bg-neutral-light-100 tw-shadow-01 dark:tw-shadow-none tw-rounded-r-1 dark:tw-border-[0.1rem] dark:tw-border-l-0 tw-border-solid tw-py-1.2 tw-px-1.6 tw-flex', TOAST_COLORS[type].otherBordersDark),
      children: [/*#__PURE__*/_jsx("div", {
        className: "tw-w-2 tw-mr-0.8",
        children: /*#__PURE__*/_jsx(ToastIcon, {
          type: type
        })
      }), /*#__PURE__*/_jsx(ToastInformation, {
        title: title,
        subtitle: subtitle,
        textLink: textLink,
        type: type
      }), /*#__PURE__*/_jsx("button", {
        type: "button",
        onClick: onClose,
        className: "tw-ml-1.2 tw-h-2",
        children: _CloseSmall || (_CloseSmall = /*#__PURE__*/_jsx(CloseSmall, {
          className: "tw-text-neutral-light-700 ",
          size: 20
        }))
      })]
    })]
  });
};